window.addEventListener("load", function () {
    const video = document.querySelector("#player");

    if (!video) return;

    const url = video.dataset.url;

    player();
});

// function player(video, watermark) {
function player(video) {
    const player = new OpenPlayerJS("player", {
        mode: "fill",
        controls: {
            alwaysVisible: false,
            layers: {
                left: ["play", "volume", "time"],
                middle: [],
                right: ["fullscreen"],
            },
        },
        showLoaderOnInit: true,
        progress: {
            duration: 0,
            showCurrentTimeOnly: true,
        },
        live: {
            showLabel: false,
            showProgress: false,
        },
        hls: {
            startLevel: -1,
            liveDurationInfinity: true,
            enableWorker: true,
            emeEnabled: true,
        },
        useDeviceVolume: false,
        pauseOthers: false,
    });

    // player.src = {
    //     src: video,
    // };

    // player.addElement({
    //     id: "watermark",
    //     type: "div",
    //     content:
    //         '<a href="https://brusqueaovivo.com" target="_blank"><img src="' +
    //         watermark +
    //         '" alt="Brusque ao Vivo"></a><span><span class="span-01"></span><span class="span-02"></span></span>',
    //     position: "main",
    //     click: () => {},
    // });

    player.init();
}

function get_video_url(url) {
    axios
        .post(url)
        .then(function (response) {
            var video = response.data.video;
            var watermark = response.data.watermark;

            player(video, watermark);
        })
        .catch(function (error) {
            console.error("get_video_url", error.message);
        });
}
